export const mail = {
    "站内信": "Site içi mesaj",
    "返回": "Geri",
    "有未读信息": "{amount} okunmamış mesaj var",
    "全部标记为已读": "Tümünü okundu olarak işaretle",
    "隐藏已读消息": "Okunmuş mesajları gizle",
    "展开": "Genişlet"
};


// WEBPACK FOOTER //
// ./src/i18n/lang/mail/tr.js